<script>
//
export let pageCopy;
export let pageTitle;
export let buttonText;
export let buttonLink;
//
let theTitle;
// let baseURL ="https://strapi.understory.community";
// let theImg = pageImage[0];
// let imgURL = baseURL + theImg.formats.small.url// ""+ JSON.stringify(theImg.formats.small.url);
// let alt = theImg.alternativeText;
 //
 if(pageTitle!== null){
	theTitle=pageTitle;

}else{
	theTitle="";
}
</script>

<section>
    <div class=" fic--cta_large-text">
    	     {#if theTitle !== ""}
            <h2>{@html theTitle}</h2>
            {/if}

        <div>
            <div class="fic--cta_text fic--cta_large-text_text">
        	   {@html pageCopy}

   		   </div>
            <div class="fic--cta_large-text_cta fic--button fic--button_cta-large">
            <a href="{ buttonLink}" >{@html buttonText }</a>
           </div>
        </div>
    </div>    
       
</section>